import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import BoreholeBrowserPage from './components/BoreholeBrowserPage';
import InterpolationMapPage from './components/InterpolationMapPage';
import ProjectPage from './components/ProjectPage';
import ProjectListPage from './components/ProjectListPage';
import ProtectedRoute from './components/ProtectedRoute';
import { NmtDownloadProvider, NmtDownloadBanner } from './contexts/NmtDownloadContext';

function App() {
  return (
    <NmtDownloadProvider>
      <NmtDownloadBanner />
      <AppRoutes />
    </NmtDownloadProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/browse"
        element={
          <ProtectedRoute>
            <BoreholeBrowserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/interpolation"
        element={
          <ProtectedRoute>
            <InterpolationMapPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor"
        element={
          <ProtectedRoute>
            <ProjectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects"
        element={
          <ProtectedRoute>
            <ProjectListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project/:projectId"
        element={
          <ProtectedRoute>
            <ProjectPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/browse" replace />} />
    </Routes>
  );
}

export default App;
